export default __webpack_public_path__ + "static/media/omotola_portrait.f4e7ab27.webp";